import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_Variable, valueID_YesNo } from '@app/hcs-shared';
import { createSearchIntegration, Dialog_Confirmation } from '@app/styles';
import { ModuleFE_Toaster } from '@nu-art/thunderstorm-frontend';
import { ConfigKeyFE_DiseasesTagId, ModuleFE_NLPData, ModuleFE_Reference, ModuleFE_Variable, Preview_Variable, resolveReferenceDisplay } from '../../_entity.js';
import { Manager_WorkHub_Variable } from '../../ui/_managers/Manager_WorkHub_Variable/Manager_WorkHub_Variable.js';
import { SearchAddOn_ByTag } from '../add-ons/SearchAddOn_ByTag/types.js';
import { displayEntityDependencies } from '@app/styles/frontend/ui/consts';
import { Renderer_SearchResult, SearchResult_BaseRightClickActions } from '@app/styles/frontend/ui/components/Renderer_SearchResult/Renderer_SearchResult';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_Variable,
    dbDef: DBDef_Variable,
    tag: ['Vr', 'Variable'],
    labelField: 'name',
    modulesToAwait: [ModuleFE_Variable],
    ManagerComponent: Manager_WorkHub_Variable,
    customDeleteAction: (variable, closeTab) => {
        Dialog_Confirmation.show({
            header: 'Are you sure?',
            content: () => _jsxs(_Fragment, { children: [_jsx("div", { children: "You're about to delete the variable" }), _jsx("div", { children: variable.name })] }),
            buttons: [
                {
                    label: 'Yes, Delete',
                    isAsync: true,
                    action: async () => {
                        await ModuleFE_Variable._v1.deleteVariable({ variableToDelete: variable }).executeSync();
                        closeTab();
                    },
                },
                {
                    label: 'Don\'t Delete',
                    isPreferred: true,
                    action: () => {
                    },
                },
            ],
        });
    },
    extraMenuSections: (_entity, tab) => [
        {
            actions: [
                {
                    label: 'Convert To Yes/Sus/No',
                    visible: () => {
                        const diseaseTagId = ConfigKeyFE_DiseasesTagId.get();
                        return _entity.type === 'normal'
                            && !!_entity._tagIds?.includes(diseaseTagId)
                            && _entity.valueId === valueID_YesNo;
                    },
                    action: async () => {
                        const variableId = _entity._id;
                        if (!variableId)
                            return;
                        try {
                            await ModuleFE_Variable._v1.convertToYesSusNo({ variableId }).executeSync();
                            ModuleFE_Toaster.toastSuccess('Converted variable to Yes/Suspected/No');
                        }
                        catch (err) {
                            const reason = err.errorResponse?.error?.data?.message;
                            ModuleFE_Toaster.toastError(`Failed to convert variable: ${reason ?? 'N/A'}`);
                        }
                    }
                },
                {
                    label: 'Check Usage',
                    action: () => displayEntityDependencies(DBDef_Variable.dbKey, tab.renderArgs.itemId),
                },
            ],
        },
    ],
    extraAddOnKeys: [SearchAddOn_ByTag.key],
    extraSearchAddOns: {
        [SearchAddOn_ByTag.methodName]: (pointer) => {
            const variable = ModuleFE_Variable.cache.unique(pointer.id);
            return variable.tagIds;
        },
    },
    searchTermsExtractor: (variable) => {
        const results = [];
        const nlpData = ModuleFE_NLPData.cache.unique(variable.nlpDataId);
        results.push(variable.name.toLowerCase());
        for (const syn of nlpData?.synonyms ?? []) {
            results.push(syn.toLowerCase());
        }
        for (const refId of variable.referenceIds) {
            const ref = ModuleFE_Reference.cache.unique(refId);
            if (ref)
                results.push(resolveReferenceDisplay(ref));
        }
        results.push(variable._id);
        return results;
    },
    resultRenderer: (pointer, style) => {
        const variable = ModuleFE_Variable.cache.unique(pointer.id);
        const nlp = ModuleFE_NLPData.cache.unique(variable?.nlpDataId);
        return _jsx(Renderer_SearchResult, { entity: variable, entityLabel: 'Variable', style: style, itemLabel: variable?.name ?? 'N/A', subtitle: nlp?.synonyms?.[0], onClickAction: () => UtilObject_Variable.openEditor(pointer.id), rightClickActions: [
                ...SearchResult_BaseRightClickActions(variable),
                { label: 'Check Usage', action: () => displayEntityDependencies(pointer.dbKey, pointer.id) },
                { label: 'Show Preview', action: () => Preview_Variable.show(pointer.id) },
            ] });
    },
});
export const WorkHubItem_Variable = WorkHubItem;
export const UtilObject_Variable = UtilObject;
export const SearchItem_Variable = SearchItem;
//# sourceMappingURL=variable.js.map